import * as MessagesActionTypes from '../../actiontypes/messages';
import accept from './accept';
import cancel from './cancel';
import closeDialog from './closeDialog';
import deleteMessage from './deleteMessage';
import fetch from './fetch';
import fetchFeedMessages from './fetchFeedMessages';
import fetchInteractions from './fetchInteractions';
import reject from './reject';


const clearNotification = () => ({type: MessagesActionTypes.CLEAR_NOTIFICATION});

export {
  clearNotification,
  accept,
  cancel,
  closeDialog,
  deleteMessage,
  fetch,
  fetchFeedMessages,
  fetchInteractions,
  reject,
};
